const TOKEN_IMAGES = {
  TSLA: 'https://s3-symbol-logo.tradingview.com/tesla--big.svg',
  NVDA: 'https://s3-symbol-logo.tradingview.com/nvidia--big.svg',
  HOOD: 'https://s3-symbol-logo.tradingview.com/robinhood--big.svg',
  PLTR: 'https://s3-symbol-logo.tradingview.com/palantir--big.svg',
  AAPL: 'https://s3-symbol-logo.tradingview.com/apple--big.svg',
  WBD: 'https://s3-symbol-logo.tradingview.com/warner-bros-discovery--big.svg',
  F: 'https://s3-symbol-logo.tradingview.com/ford--big.svg',
  SNAP: 'https://s3-symbol-logo.tradingview.com/snap--big.svg',
  AMD: 'https://s3-symbol-logo.tradingview.com/advanced-micro-devices--big.svg',
  INTC: 'https://s3-symbol-logo.tradingview.com/intel--big.svg',
  SMCI: 'https://s3-symbol-logo.tradingview.com/super-micro-computer--big.svg',
  MARA: 'https://s3-symbol-logo.tradingview.com/marathon-digital-holdings--big.svg',
  RKLB: 'https://s3-symbol-logo.tradingview.com/rocket-lab--big.svg',
  RIOT: 'https://s3-symbol-logo.tradingview.com/riot-blockchain--big.svg',
  AMC: 'https://s3-symbol-logo.tradingview.com/amc-entertainment-holdings--big.svg',
  CRCL: 'https://s3-symbol-logo.tradingview.com/circle-internet-group-inc--big.svg',
  VALE: 'https://s3-symbol-logo.tradingview.com/vale--big.svg',
  AMZN: 'https://s3-symbol-logo.tradingview.com/amazon--big.svg',
  PFE: 'https://s3-symbol-logo.tradingview.com/pfizer--big.svg',
  GOOGL: 'https://s3-symbol-logo.tradingview.com/alphabet--big.svg',
  CCL: 'https://s3-symbol-logo.tradingview.com/carnival--big.svg',
  NKE: 'https://s3-symbol-logo.tradingview.com/nike--big.svg',
  MU: 'https://s3-symbol-logo.tradingview.com/micron-technology--big.svg',
  HBAN: 'https://s3-symbol-logo.tradingview.com/huntington-bancshares--big.svg',
  BAC: 'https://s3-symbol-logo.tradingview.com/bank-of-america--big.svg',
  AMCR: 'https://s3-symbol-logo.tradingview.com/amcor--big.svg',
  GOOG: 'https://s3-symbol-logo.tradingview.com/alphabet--big.svg',
  AVGO: 'https://s3-symbol-logo.tradingview.com/broadcom--big.svg',
  KHC: 'https://s3-symbol-logo.tradingview.com/kraft-heinz--big.svg',
  T: 'https://s3-symbol-logo.tradingview.com/at-and-t--big.svg',
  HPE: 'https://s3-symbol-logo.tradingview.com/hewlett-packard-enterprise--big.svg',
  ORCL: 'https://s3-symbol-logo.tradingview.com/oracle--big.svg',
  PCG: 'https://s3-symbol-logo.tradingview.com/pg-and-e--big.svg',
  CMG: 'https://s3-symbol-logo.tradingview.com/chipotle-mexican-grill--big.svg',
  UNH: 'https://s3-symbol-logo.tradingview.com/unitedhealth--big.svg',
  MSTR: 'https://s3-symbol-logo.tradingview.com/microstrategy--big.svg',
  MRVL: 'https://s3-symbol-logo.tradingview.com/marvell-tech--big.svg',
  COIN: 'https://s3-symbol-logo.tradingview.com/coinbase--big.svg',
  NEE: 'https://s3-symbol-logo.tradingview.com/nextera-energy--big.svg',
  WFC: 'https://s3-symbol-logo.tradingview.com/wells-fargo--big.svg',
  KO: 'https://s3-symbol-logo.tradingview.com/coca-cola--big.svg',
  CSCO: 'https://s3-symbol-logo.tradingview.com/cisco--big.svg',
  WMT: 'https://s3-symbol-logo.tradingview.com/walmart--big.svg',
  NCLH: 'https://s3-symbol-logo.tradingview.com/norwegian-cruise-line--big.svg',
  VZ: 'https://s3-symbol-logo.tradingview.com/verizon--big.svg',
  MSFT: 'https://s3-symbol-logo.tradingview.com/microsoft--big.svg',
  AES: 'https://s3-symbol-logo.tradingview.com/aes--big.svg',
  WMB: 'https://s3-symbol-logo.tradingview.com/williams--big.svg',
  UBER: 'https://s3-symbol-logo.tradingview.com/uber--big.svg',
  BMY: 'https://s3-symbol-logo.tradingview.com/bristol-myers-squibb--big.svg',
  CMCSA: 'https://s3-symbol-logo.tradingview.com/comcast--big.svg',
  MRK: 'https://s3-symbol-logo.tradingview.com/merck-and-co--big.svg',
  XOM: 'https://s3-symbol-logo.tradingview.com/exxon--big.svg',
  META: 'https://s3-symbol-logo.tradingview.com/meta-platforms--big.svg',
  KVUE: 'https://s3-symbol-logo.tradingview.com/kenvue--big.svg',
  USB: 'https://s3-symbol-logo.tradingview.com/us-bancorp--big.svg',
  LVS: 'https://s3-symbol-logo.tradingview.com/las-vegas-sands--big.svg',
  TTD: 'https://s3-symbol-logo.tradingview.com/the-trade-desk--big.svg',
  TSM: 'https://s3-symbol-logo.tradingview.com/taiwan-semiconductor--big.svg',
  KEY: 'https://s3-symbol-logo.tradingview.com/keycorp--big.svg',
  RDDT: 'https://s3-symbol-logo.tradingview.com/reddit--big.svg',
  KMI: 'https://s3-symbol-logo.tradingview.com/kinder-morgan--big.svg',
  EQT: 'https://s3-symbol-logo.tradingview.com/eqt--big.svg',
  PEP: 'https://s3-symbol-logo.tradingview.com/pepsico--big.svg',
  DOW: 'https://s3-symbol-logo.tradingview.com/dow--big.svg',
  C: 'https://s3-symbol-logo.tradingview.com/citigroup--big.svg',
  CSX: 'https://s3-symbol-logo.tradingview.com/csx--big.svg',
  GM: 'https://s3-symbol-logo.tradingview.com/general-motors--big.svg',
  NEM: 'https://s3-symbol-logo.tradingview.com/newmont--big.svg',
  MDLZ: 'https://s3-symbol-logo.tradingview.com/mondelez--big.svg',
  AZN: 'https://s3-symbol-logo.tradingview.com/astrazeneca--big.svg',
  FCX: 'https://s3-symbol-logo.tradingview.com/freeport-mcmoran--big.svg',
  MGM: 'https://s3-symbol-logo.tradingview.com/mgm-resorts--big.svg',
  ENPH: 'https://s3-symbol-logo.tradingview.com/enphase-energy--big.svg',
  VTRS: 'https://s3-symbol-logo.tradingview.com/viatris--big.svg',
  PG: 'https://s3-symbol-logo.tradingview.com/procter-and-gamble--big.svg',
  LRCX: 'https://s3-symbol-logo.tradingview.com/lam-research--big.svg',
  RBLX: 'https://s3-symbol-logo.tradingview.com/roblox--big.svg',
  HAL: 'https://s3-symbol-logo.tradingview.com/halliburton--big.svg',
  DAL: 'https://s3-symbol-logo.tradingview.com/delta-air-lines--big.svg',
  CPNG: 'https://s3-symbol-logo.tradingview.com/coupang--big.svg',
  GME: 'https://s3-symbol-logo.tradingview.com/gamestop--big.svg',
  ARM: 'https://s3-symbol-logo.tradingview.com/arm--big.svg',
  SLB: 'https://s3-symbol-logo.tradingview.com/schlumberger--big.svg',
  TGT: 'https://s3-symbol-logo.tradingview.com/target--big.svg',
  LUV: 'https://s3-symbol-logo.tradingview.com/southwest--big.svg',
  MRNA: 'https://s3-symbol-logo.tradingview.com/moderna--big.svg',
  SBUX: 'https://s3-symbol-logo.tradingview.com/starbucks--big.svg',
  JPM: 'https://s3-symbol-logo.tradingview.com/jpmorgan-chase--big.svg',
  NVO: 'https://s3-symbol-logo.tradingview.com/novo-nordisk--big.svg',
  WYNN: 'https://s3-symbol-logo.tradingview.com/wynn-resorts--big.svg',
  OXY: 'https://s3-symbol-logo.tradingview.com/occidental-petroleum--big.svg',
  DIS: 'https://s3-symbol-logo.tradingview.com/walt-disney--big.svg',
  KDP: 'https://s3-symbol-logo.tradingview.com/keurig-dr-pepper--big.svg',
  BA: 'https://s3-symbol-logo.tradingview.com/boeing--big.svg',
  FSLR: 'https://s3-symbol-logo.tradingview.com/first-solar--big.svg',
  PARA: 'https://s3-symbol-logo.tradingview.com/viacomcbs--big.svg',
  HPQ: 'https://s3-symbol-logo.tradingview.com/hp--big.svg',
  RF: 'https://s3-symbol-logo.tradingview.com/regions-financial--big.svg',
  CNC: 'https://s3-symbol-logo.tradingview.com/centene--big.svg',
  ANET: 'https://s3-symbol-logo.tradingview.com/arista-networks--big.svg',
  SCHW: 'https://s3-symbol-logo.tradingview.com/schwab--big.svg',
  V: 'https://s3-symbol-logo.tradingview.com/visa--big.svg',
  IPG: 'https://s3-symbol-logo.tradingview.com/interpublic-group-cos--big.svg',
  CRM: 'https://s3-symbol-logo.tradingview.com/salesforce--big.svg',
  VST: 'https://s3-symbol-logo.tradingview.com/vistra-energy--big.svg',
  JNJ: 'https://s3-symbol-logo.tradingview.com/johnson-and-johnson--big.svg',
  WBA: 'https://s3-symbol-logo.tradingview.com/walgreens-boots-alliance--big.svg',
  CAG: 'https://s3-symbol-logo.tradingview.com/conagra-brands--big.svg',
  CVX: 'https://s3-symbol-logo.tradingview.com/chevron--big.svg',
  TFC: 'https://s3-symbol-logo.tradingview.com/truist-financial--big.svg',
  APP: 'https://s3-symbol-logo.tradingview.com/applovin--big.svg',
  PYPL: 'https://s3-symbol-logo.tradingview.com/paypal--big.svg',
  ON: 'https://s3-symbol-logo.tradingview.com/on-semiconductor--big.svg',
  CTRA: 'https://s3-symbol-logo.tradingview.com/alpha-metallurgical-resources--big.svg',
  TSCO: 'https://s3-symbol-logo.tradingview.com/tractor-supply--big.svg',
  FTV: 'https://s3-symbol-logo.tradingview.com/fortive--big.svg',
  MO: 'https://s3-symbol-logo.tradingview.com/altria--big.svg',
  EL: 'https://s3-symbol-logo.tradingview.com/estee-lauder--big.svg',
  GIS: 'https://s3-symbol-logo.tradingview.com/general-mills--big.svg',
  APH: 'https://s3-symbol-logo.tradingview.com/amphenol--big.svg',
  PLD: 'https://s3-symbol-logo.tradingview.com/prologis--big.svg',
  DOC: 'https://s3-symbol-logo.tradingview.com/healthpeak-properties--big.svg',
  O: 'https://s3-symbol-logo.tradingview.com/realty-income--big.svg',
  GE: 'https://s3-symbol-logo.tradingview.com/ge-aerospace--big.svg',
  CPRT: 'https://s3-symbol-logo.tradingview.com/copart--big.svg',
  EXC: 'https://s3-symbol-logo.tradingview.com/exelon--big.svg',
  CZR: 'https://s3-symbol-logo.tradingview.com/caesars--big.svg',
  UPST: 'https://s3-symbol-logo.tradingview.com/upstart--big.svg',
  GILD: 'https://s3-symbol-logo.tradingview.com/gilead--big.svg',
  TRMB: 'https://s3-symbol-logo.tradingview.com/trimble--big.svg',
  BSX: 'https://s3-symbol-logo.tradingview.com/boston-scientific--big.svg',
  DVN: 'https://s3-symbol-logo.tradingview.com/devon-energy--big.svg',
  FOXA: 'https://s3-symbol-logo.tradingview.com/fox-corporation--big.svg',
  GEV: 'https://s3-symbol-logo.tradingview.com/ge-verona--big.svg',
  MDT: 'https://s3-symbol-logo.tradingview.com/medtronic--big.svg',
  MOS: 'https://s3-symbol-logo.tradingview.com/mosaic--big.svg',
  AI: 'https://s3-symbol-logo.tradingview.com/c3-ai--big.svg',
  DASH: 'https://s3-symbol-logo.tradingview.com/doordash--big.svg',
  BKR: 'https://s3-symbol-logo.tradingview.com/baker-hughes--big.svg',
  PANW: 'https://s3-symbol-logo.tradingview.com/palo-alto-networks--big.svg',
  MCHP: 'https://s3-symbol-logo.tradingview.com/microchip-technology--big.svg',
  QCOM: 'https://s3-symbol-logo.tradingview.com/qualcomm--big.svg',
  CPB: 'https://s3-symbol-logo.tradingview.com/campbell-soup--big.svg',
  UPS: 'https://s3-symbol-logo.tradingview.com/united-parcel--big.svg',
  DXCM: 'https://s3-symbol-logo.tradingview.com/dexcom--big.svg',
  ZS: 'https://s3-symbol-logo.tradingview.com/zscaler--big.svg',
  HWM: 'https://s3-symbol-logo.tradingview.com/howmet-aerospace--big.svg',
  NFLX: 'https://s3-symbol-logo.tradingview.com/netflix--big.svg',
  ADBE: 'https://s3-symbol-logo.tradingview.com/adobe--big.svg',
  EBAY: 'https://s3-symbol-logo.tradingview.com/ebay--big.svg',
  FAST: 'https://s3-symbol-logo.tradingview.com/fastenal--big.svg',
  ZTS: 'https://s3-symbol-logo.tradingview.com/zoetis--big.svg',
  D: 'https://s3-symbol-logo.tradingview.com/dominion-energy--big.svg',
  MS: 'https://s3-symbol-logo.tradingview.com/morgan-stanley--big.svg',
  K: 'https://s3-symbol-logo.tradingview.com/kellogg--big.svg',
  UAL: 'https://s3-symbol-logo.tradingview.com/united-airlines--big.svg',
  PDD: 'https://s3-symbol-logo.tradingview.com/pinduoduo--big.svg',
  LULU: 'https://s3-symbol-logo.tradingview.com/lululemon-athletica--big.svg',
  MNST: 'https://s3-symbol-logo.tradingview.com/monster-beverage--big.svg',
  SO: 'https://s3-symbol-logo.tradingview.com/southern--big.svg',
  STX: 'https://s3-symbol-logo.tradingview.com/seagate--big.svg',
  DELL: 'https://s3-symbol-logo.tradingview.com/dell--big.svg',
  CRWD: 'https://s3-symbol-logo.tradingview.com/crowdstrike--big.svg',
  MA: 'https://s3-symbol-logo.tradingview.com/mastercard--big.svg',
  RIO: 'https://s3-symbol-logo.tradingview.com/rio-tinto--big.svg',
  CVS: 'https://s3-symbol-logo.tradingview.com/cvs-health--big.svg',
  HST: 'https://s3-symbol-logo.tradingview.com/host-hotels--big.svg',
  FE: 'https://s3-symbol-logo.tradingview.com/firstenergy--big.svg',
  HD: 'https://s3-symbol-logo.tradingview.com/home-depot--big.svg',
  WY: 'https://s3-symbol-logo.tradingview.com/weyerhaeuserdrn--big.svg',
  OMC: 'https://s3-symbol-logo.tradingview.com/omnicom-group--big.svg',
  CEG: 'https://s3-symbol-logo.tradingview.com/constellation-energy--big.svg',
  ABBV: 'https://s3-symbol-logo.tradingview.com/abbvie--big.svg',
  DDOG: 'https://s3-symbol-logo.tradingview.com/datadog--big.svg',
  COP: 'https://s3-symbol-logo.tradingview.com/conocophillips--big.svg',
  MKC: 'https://s3-symbol-logo.tradingview.com/mccormick--big.svg',
  TJX: 'https://s3-symbol-logo.tradingview.com/tjx-cos--big.svg',
  ABT: 'https://s3-symbol-logo.tradingview.com/abbott--big.svg',
  BBY: 'https://s3-symbol-logo.tradingview.com/best-buy--big.svg',
  FTNT: 'https://s3-symbol-logo.tradingview.com/fortinet--big.svg',
  XEL: 'https://s3-symbol-logo.tradingview.com/xcel-energy--big.svg',
  HON: 'https://s3-symbol-logo.tradingview.com/honeywell--big.svg',
  KR: 'https://s3-symbol-logo.tradingview.com/kroger--big.svg',
  LEN: 'https://s3-symbol-logo.tradingview.com/lennar--big.svg',
  MCD: 'https://s3-symbol-logo.tradingview.com/mcdonalds--big.svg',
  PPL: 'https://s3-symbol-logo.tradingview.com/ppl--big.svg',
  DHI: 'https://s3-symbol-logo.tradingview.com/dr-horton--big.svg',
  WDC: 'https://s3-symbol-logo.tradingview.com/webster-financial--big.svg',
  APA: 'https://s3-symbol-logo.tradingview.com/apa-corporation--big.svg',
  ORLY: 'https://s3-symbol-logo.tradingview.com/o-reilly-auto--big.svg',
  HAS: 'https://s3-symbol-logo.tradingview.com/hasbro--big.svg',
  GS: 'https://s3-symbol-logo.tradingview.com/golden-sachs-etf-trust-goldman--big.svg',
  AMAT: 'https://s3-symbol-logo.tradingview.com/applied-materials--big.svg',
  CFG: 'https://s3-symbol-logo.tradingview.com/citizens-financial-group--big.svg',
  TMUS: 'https://s3-symbol-logo.tradingview.com/t-mobile--big.svg',
  BX: 'https://s3-symbol-logo.tradingview.com/blackstone--big.svg',
  ABNB: 'https://s3-symbol-logo.tradingview.com/airbnb--big.svg',
  VICI: 'https://s3-symbol-logo.tradingview.com/vici-properties--big.svg',
  RCL: 'https://s3-symbol-logo.tradingview.com/royal-caribbean-cruises--big.svg',
  JCI: 'https://s3-symbol-logo.tradingview.com/johnson-controls--big.svg',
  EOG: 'https://s3-symbol-logo.tradingview.com/eog--big.svg',
  FI: 'https://s3-symbol-logo.tradingview.com/fiserv--big.svg',
  ALB: 'https://s3-symbol-logo.tradingview.com/albemarle--big.svg',
  MTCH: 'https://s3-symbol-logo.tradingview.com/match-group-inc--big.svg',
  PAYX: 'https://s3-symbol-logo.tradingview.com/paychex--big.svg',
  BK: 'https://s3-symbol-logo.tradingview.com/bank-of-new-york-mellon--big.svg',
  CNP: 'https://s3-symbol-logo.tradingview.com/centerpoint-energy--big.svg',
  FITB: 'https://s3-symbol-logo.tradingview.com/fifth-third-bancorp--big.svg',
  IP: 'https://s3-symbol-logo.tradingview.com/international-paper--big.svg',
  SW: 'https://s3-symbol-logo.tradingview.com/smurfit-kappa--big.svg',
  TPR: 'https://s3-symbol-logo.tradingview.com/tapestry--big.svg',
  LOW: 'https://s3-symbol-logo.tradingview.com/lowe-s--big.svg',
  PM: 'https://s3-symbol-logo.tradingview.com/philip-morris--big.svg',
  BLDR: 'https://s3-symbol-logo.tradingview.com/builders-firstsource--big.svg',
  CARR: 'https://s3-symbol-logo.tradingview.com/carrier-global-corporation--big.svg',
  CI: 'https://s3-symbol-logo.tradingview.com/cigna--big.svg',
  EIX: 'https://s3-symbol-logo.tradingview.com/edison-international--big.svg',
  BEN: 'https://s3-symbol-logo.tradingview.com/franklin-resources--big.svg',
  RTX: 'https://s3-symbol-logo.tradingview.com/raytheon--big.svg',
  TXN: 'https://s3-symbol-logo.tradingview.com/texas-instruments--big.svg',
  PGR: 'https://s3-symbol-logo.tradingview.com/progressive-ohio--big.svg',
  LYB: 'https://s3-symbol-logo.tradingview.com/lyondellbasell--big.svg',
  BRO: 'https://s3-symbol-logo.tradingview.com/brown-and-brown--big.svg',
  INVH: 'https://s3-symbol-logo.tradingview.com/invitation-homes--big.svg',
  TECH: 'https://s3-symbol-logo.tradingview.com/bio-techne--big.svg',
  DUK: 'https://s3-symbol-logo.tradingview.com/duke-energy--big.svg',
  LLY: 'https://s3-symbol-logo.tradingview.com/eli-lilly--big.svg',
  STZ: 'https://s3-symbol-logo.tradingview.com/constellation-brands--big.svg',
  OKE: 'https://s3-symbol-logo.tradingview.com/oneok--big.svg',
  VTR: 'https://s3-symbol-logo.tradingview.com/ventas--big.svg',
  GEHC: 'https://s3-symbol-logo.tradingview.com/ge-healthcare-technologies--big.svg',
  HLT: 'https://s3-symbol-logo.tradingview.com/hilton-worldwide--big.svg',
  WDAY: 'https://s3-symbol-logo.tradingview.com/workday--big.svg',
  KIM: 'https://s3-symbol-logo.tradingview.com/kimco-realty-hc--big.svg',
  MMM: 'https://s3-symbol-logo.tradingview.com/3m--big.svg',
  AEP: 'https://s3-symbol-logo.tradingview.com/american-electric-power--big.svg',
  NRG: 'https://s3-symbol-logo.tradingview.com/nrg-energy--big.svg',
  PNC: 'https://s3-symbol-logo.tradingview.com/pnc-financial--big.svg',
  DECK: 'https://s3-symbol-logo.tradingview.com/deckers-outdoor--big.svg',
  IFF: 'https://s3-symbol-logo.tradingview.com/international-flavors-and-fragrances--big.svg',
  AXP: 'https://s3-symbol-logo.tradingview.com/american-express--big.svg',
  CCI: 'https://s3-symbol-logo.tradingview.com/crown-castle-international--big.svg',
  DG: 'https://s3-symbol-logo.tradingview.com/dollar-general--big.svg',
  COF: 'https://s3-symbol-logo.tradingview.com/capital-one--big.svg',
  ROST: 'https://s3-symbol-logo.tradingview.com/ross-stores--big.svg',
  SRE: 'https://s3-symbol-logo.tradingview.com/sempra-energy--big.svg',
  IBM: 'https://s3-symbol-logo.tradingview.com/international-bus-mach--big.svg',
  NTRS: 'https://s3-symbol-logo.tradingview.com/northern-trust--big.svg',
  GLW: 'https://s3-symbol-logo.tradingview.com/corning--big.svg',
  IVZ: 'https://s3-symbol-logo.tradingview.com/invesco--big.svg',
  KKR: 'https://s3-symbol-logo.tradingview.com/kkr--big.svg',
  KMX: 'https://s3-symbol-logo.tradingview.com/carmax--big.svg',
  AMGN: 'https://s3-symbol-logo.tradingview.com/amgen--big.svg',
  SYF: 'https://s3-symbol-logo.tradingview.com/synchrony--big.svg',
  HSY: 'https://s3-symbol-logo.tradingview.com/hershey--big.svg',
  EMN: 'https://s3-symbol-logo.tradingview.com/eastman--big.svg',
  LW: 'https://s3-symbol-logo.tradingview.com/lamb-weston-hldgs--big.svg',
  MAS: 'https://s3-symbol-logo.tradingview.com/masco--big.svg',
  AEM: 'https://s3-symbol-logo.tradingview.com/agnico-eagle-mines--big.svg',
  SJM: 'https://s3-symbol-logo.tradingview.com/smucker--big.svg',
  ACN: 'https://s3-symbol-logo.tradingview.com/accenture--big.svg',
  NDAQ: 'https://s3-symbol-logo.tradingview.com/nasdaq--big.svg',
  BDX: 'https://s3-symbol-logo.tradingview.com/becton-dickinson--big.svg',
  DLTR: 'https://s3-symbol-logo.tradingview.com/dollar-tree--big.svg',
  ED: 'https://s3-symbol-logo.tradingview.com/consolidated-edison--big.svg',
  EW: 'https://s3-symbol-logo.tradingview.com/edwards--big.svg',
  CAT: 'https://s3-symbol-logo.tradingview.com/caterpillar--big.svg',
  PCAR: 'https://s3-symbol-logo.tradingview.com/paccar--big.svg',
  AIG: 'https://s3-symbol-logo.tradingview.com/american-international--big.svg',
  GEN: 'https://s3-symbol-logo.tradingview.com/nortonlifelock--big.svg',
  TMO: 'https://s3-symbol-logo.tradingview.com/thermo-fisher-scientific--big.svg',
  SWKS: 'https://s3-symbol-logo.tradingview.com/skyworks-solutions--big.svg',
  CTSH: 'https://s3-symbol-logo.tradingview.com/cognizant--big.svg',
  ADI: 'https://s3-symbol-logo.tradingview.com/analog-devices--big.svg',
  ADM: 'https://s3-symbol-logo.tradingview.com/archer-daniels-midland--big.svg',
  BHP: 'https://s3-symbol-logo.tradingview.com/bhp--big.svg',
  DHR: 'https://s3-symbol-logo.tradingview.com/danaher--big.svg',
  TEAM: 'https://s3-symbol-logo.tradingview.com/atlassian--big.svg',
  WELL: 'https://s3-symbol-logo.tradingview.com/welltower-indrn--big.svg',
  STRK: 'https://s3-symbol-logo.tradingview.com/microstrategy--big.svg',
  PHM: 'https://s3-symbol-logo.tradingview.com/pulte-group--big.svg',
  SYY: 'https://s3-symbol-logo.tradingview.com/sysco--big.svg',
  ODFL: 'https://s3-symbol-logo.tradingview.com/old-dominion--big.svg',
  BAX: 'https://s3-symbol-logo.tradingview.com/baxter--big.svg',
  HES: 'https://s3-symbol-logo.tradingview.com/hess--big.svg',
  AMT: 'https://s3-symbol-logo.tradingview.com/american-tower--big.svg',
  FDX: 'https://s3-symbol-logo.tradingview.com/fedex--big.svg',
  CHD: 'https://s3-symbol-logo.tradingview.com/church-and-dwight--big.svg',
  CTVA: 'https://s3-symbol-logo.tradingview.com/corteva--big.svg',
  COO: 'https://s3-symbol-logo.tradingview.com/cooper-cos--big.svg',
  KMB: 'https://s3-symbol-logo.tradingview.com/kimberly-clark--big.svg',
  JBL: 'https://s3-symbol-logo.tradingview.com/jabil--big.svg',
  EMR: 'https://s3-symbol-logo.tradingview.com/emerson--big.svg',
  NI: 'https://s3-symbol-logo.tradingview.com/nisource--big.svg',
  ETN: 'https://s3-symbol-logo.tradingview.com/eaton--big.svg',
  COST: 'https://s3-symbol-logo.tradingview.com/costco-wholesale--big.svg',
  PWR: 'https://s3-symbol-logo.tradingview.com/quanta-services--big.svg',
  CME: 'https://s3-symbol-logo.tradingview.com/cme--big.svg',
  CSGP: 'https://s3-symbol-logo.tradingview.com/costar-group--big.svg',
  FIS: 'https://s3-symbol-logo.tradingview.com/fidelity-information-services--big.svg',
  EQR: 'https://s3-symbol-logo.tradingview.com/equity-residential--big.svg',
  VLO: 'https://s3-symbol-logo.tradingview.com/valero-energy--big.svg',
  EXPE: 'https://s3-symbol-logo.tradingview.com/expedia--big.svg',
  ADP: 'https://s3-symbol-logo.tradingview.com/automatic-data-processing--big.svg',
  MMC: 'https://s3-symbol-logo.tradingview.com/marsh-and-mclennan--big.svg',
  PEG: 'https://s3-symbol-logo.tradingview.com/public-service-enterprise--big.svg',
  ETR: 'https://s3-symbol-logo.tradingview.com/entergy--big.svg',
  FANG: 'https://s3-symbol-logo.tradingview.com/diamondback--big.svg',
  CLX: 'https://s3-symbol-logo.tradingview.com/clorox--big.svg',
  SWK: 'https://s3-symbol-logo.tradingview.com/stanley-black-and-decker--big.svg',
  NXPI: 'https://s3-symbol-logo.tradingview.com/nxp-semiconductors--big.svg',
  APO: 'https://s3-symbol-logo.tradingview.com/apollo--big.svg',
  BWA: 'https://s3-symbol-logo.tradingview.com/borg-warner--big.svg',
  DE: 'https://s3-symbol-logo.tradingview.com/deere--big.svg',
  TSN: 'https://s3-symbol-logo.tradingview.com/tyson-foods--big.svg',
  ICE: 'https://s3-symbol-logo.tradingview.com/intercontinental-exchange--big.svg',
  IR: 'https://s3-symbol-logo.tradingview.com/ingersoll-rand--big.svg',
  DLR: 'https://s3-symbol-logo.tradingview.com/digital-realty-trust-5850-series-k-cumulative-redeemable-preferred-stock-par-value-001-per-share--big.svg',
  CF: 'https://s3-symbol-logo.tradingview.com/cf-industries--big.svg',
  UNP: 'https://s3-symbol-logo.tradingview.com/union-pacific--big.svg',
  ELV: 'https://s3-symbol-logo.tradingview.com/anthem--big.svg',
  BG: 'https://s3-symbol-logo.tradingview.com/bunge--big.svg',
  TER: 'https://s3-symbol-logo.tradingview.com/teradyne--big.svg',
  IRM: 'https://s3-symbol-logo.tradingview.com/iron-mountain-incorporated-delaware--big.svg',
  NWSA: 'https://s3-symbol-logo.tradingview.com/news-corporation--big.svg',
  TAP: 'https://s3-symbol-logo.tradingview.com/molson-coors--big.svg',
  HRL: 'https://s3-symbol-logo.tradingview.com/hormel-foods--big.svg',
  ADSK: 'https://s3-symbol-logo.tradingview.com/autodesk--big.svg',
  TXT: 'https://s3-symbol-logo.tradingview.com/textron--big.svg',
  MET: 'https://s3-symbol-logo.tradingview.com/metlife--big.svg',
  GRND: 'https://s3-symbol-logo.tradingview.com/grindr--big.svg',
  CE: 'https://s3-symbol-logo.tradingview.com/celanese--big.svg',
  ASML: 'https://s3-symbol-logo.tradingview.com/asml--big.svg',
  CB: 'https://s3-symbol-logo.tradingview.com/chubb--big.svg',
  SHW: 'https://s3-symbol-logo.tradingview.com/sherwin-williams--big.svg',
  TRGP: 'https://s3-symbol-logo.tradingview.com/targa-resources--big.svg',
  SCCO: 'https://s3-symbol-logo.tradingview.com/southern-copper--big.svg',
  CMS: 'https://s3-symbol-logo.tradingview.com/cms-energy--big.svg',
  LYV: 'https://s3-symbol-logo.tradingview.com/live-nation--big.svg',
  AEE: 'https://s3-symbol-logo.tradingview.com/ameren--big.svg',
  PSX: 'https://s3-symbol-logo.tradingview.com/phillips-66--big.svg',
  INTU: 'https://s3-symbol-logo.tradingview.com/intuit--big.svg',
  ACGL: 'https://s3-symbol-logo.tradingview.com/arch-capital--big.svg',
  FMC: 'https://s3-symbol-logo.tradingview.com/fmc--big.svg',
  WM: 'https://s3-symbol-logo.tradingview.com/waste-management--big.svg',
  LIN: 'https://s3-symbol-logo.tradingview.com/linde--big.svg',
  OTIS: 'https://s3-symbol-logo.tradingview.com/otis-worldwide--big.svg',
  STT: 'https://s3-symbol-logo.tradingview.com/state-street--big.svg',
  PKG: 'https://s3-symbol-logo.tradingview.com/packaging-of-america--big.svg',
  MSI: 'https://s3-symbol-logo.tradingview.com/motorola-solutions--big.svg',
  ROL: 'https://s3-symbol-logo.tradingview.com/rollins--big.svg',
  BIIB: 'https://s3-symbol-logo.tradingview.com/biogen--big.svg',
  APTV: 'https://s3-symbol-logo.tradingview.com/aptiv--big.svg',
  DAY: 'https://s3-symbol-logo.tradingview.com/ceridian-hcm--big.svg',
  CHTR: 'https://s3-symbol-logo.tradingview.com/charter--big.svg',
  AFL: 'https://s3-symbol-logo.tradingview.com/aflac--big.svg',
  CAH: 'https://s3-symbol-logo.tradingview.com/cardinal-health--big.svg',
  JBHT: 'https://s3-symbol-logo.tradingview.com/j-b-hunt--big.svg',
  CTAS: 'https://s3-symbol-logo.tradingview.com/cintas--big.svg',
  ALL: 'https://s3-symbol-logo.tradingview.com/allstate--big.svg',
  SPG: 'https://s3-symbol-logo.tradingview.com/simon-property--big.svg',
  TTWO: 'https://s3-symbol-logo.tradingview.com/take-two-interactive-software--big.svg',
  REGN: 'https://s3-symbol-logo.tradingview.com/regeneron-pharmaceuticals--big.svg',
  EXR: 'https://s3-symbol-logo.tradingview.com/extra-space-storage--big.svg',
  DD: 'https://s3-symbol-logo.tradingview.com/dupont-de-nemours--big.svg',
  HUM: 'https://s3-symbol-logo.tradingview.com/humana--big.svg',
  CDNS: 'https://s3-symbol-logo.tradingview.com/cadence-design-systems--big.svg',
  EA: 'https://s3-symbol-logo.tradingview.com/electronic-arts--big.svg',
  SNPS: 'https://s3-symbol-logo.tradingview.com/synopsys--big.svg',
  A: 'https://s3-symbol-logo.tradingview.com/agilent-technologies--big.svg',
  PODD: 'https://s3-symbol-logo.tradingview.com/insulet--big.svg',
  PPG: 'https://s3-symbol-logo.tradingview.com/ppg-industries--big.svg',
  MDB: 'https://s3-symbol-logo.tradingview.com/mongodb--big.svg',
  XYL: 'https://s3-symbol-logo.tradingview.com/xylem--big.svg',
  LNT: 'https://s3-symbol-logo.tradingview.com/alliant-energy--big.svg',
  CHRW: 'https://s3-symbol-logo.tradingview.com/ch-robinson--big.svg',
  ES: 'https://s3-symbol-logo.tradingview.com/eversource-energy--big.svg',
  MAR: 'https://s3-symbol-logo.tradingview.com/marriott--big.svg',
  CCEP: 'https://s3-symbol-logo.tradingview.com/coca-cola--big.svg',
  WEC: 'https://s3-symbol-logo.tradingview.com/wec-energy--big.svg',
  MOH: 'https://s3-symbol-logo.tradingview.com/molina-healthcare--big.svg',
  BALL: 'https://s3-symbol-logo.tradingview.com/ball--big.svg',
  DTE: 'https://s3-symbol-logo.tradingview.com/dte-energy--big.svg',
  AKAM: 'https://s3-symbol-logo.tradingview.com/akamai--big.svg',
  EVRG: 'https://s3-symbol-logo.tradingview.com/evergy--big.svg',
  TT: 'https://s3-symbol-logo.tradingview.com/trane-technologies--big.svg',
  LKQ: 'https://s3-symbol-logo.tradingview.com/lkq--big.svg',
  ISRG: 'https://s3-symbol-logo.tradingview.com/intuitive-surgical--big.svg',
  GFS: 'https://s3-symbol-logo.tradingview.com/globalfoundries--big.svg',
  VRTX: 'https://s3-symbol-logo.tradingview.com/vertex-pharmaceutical--big.svg',
  HOLX: 'https://s3-symbol-logo.tradingview.com/hologic--big.svg',
  LMT: 'https://s3-symbol-logo.tradingview.com/lockheed-martin--big.svg',
  UDR: 'https://s3-symbol-logo.tradingview.com/udr--big.svg',
  MPC: 'https://s3-symbol-logo.tradingview.com/marathon-petroleum--big.svg',
  YUM: 'https://s3-symbol-logo.tradingview.com/yum-brands--big.svg',
  HSIC: 'https://s3-symbol-logo.tradingview.com/henry-schein--big.svg',
  NSC: 'https://s3-symbol-logo.tradingview.com/norfolk-southern--big.svg',
  TROW: 'https://s3-symbol-logo.tradingview.com/rowe-price--big.svg',
  INCY: 'https://s3-symbol-logo.tradingview.com/incyte--big.svg',
  AJG: 'https://s3-symbol-logo.tradingview.com/gallagher--big.svg',
  ZBH: 'https://s3-symbol-logo.tradingview.com/zimmer-biomet--big.svg',
  PRU: 'https://s3-symbol-logo.tradingview.com/prudential--big.svg',
  RSG: 'https://s3-symbol-logo.tradingview.com/republic-services--big.svg',
  DRI: 'https://s3-symbol-logo.tradingview.com/darden--big.svg',
  ARE: 'https://s3-symbol-logo.tradingview.com/alexandria-real-estate-equities--big.svg',
  APD: 'https://s3-symbol-logo.tradingview.com/air-products-and-chemicals--big.svg',
  NTAP: 'https://s3-symbol-logo.tradingview.com/netapp--big.svg',
  BXP: 'https://s3-symbol-logo.tradingview.com/boston-prop-drn--big.svg',
  GPN: 'https://s3-symbol-logo.tradingview.com/global-payments--big.svg',
  STE: 'https://s3-symbol-logo.tradingview.com/steris--big.svg',
  SPGI: 'https://s3-symbol-logo.tradingview.com/s-and-p-global--big.svg',
  SGML: 'https://s3-symbol-logo.tradingview.com/sigma-lithium--big.svg',
  NUE: 'https://s3-symbol-logo.tradingview.com/nucor--big.svg',
  ITW: 'https://s3-symbol-logo.tradingview.com/illinois-tool-works--big.svg',
  STLD: 'https://s3-symbol-logo.tradingview.com/steel-dynamics--big.svg',
  TEL: 'https://s3-symbol-logo.tradingview.com/te-connectivity--big.svg',
  IQV: 'https://s3-symbol-logo.tradingview.com/iqvia--big.svg',
  REG: 'https://s3-symbol-logo.tradingview.com/regency-centers--big.svg',
  PNR: 'https://s3-symbol-logo.tradingview.com/pentair--big.svg',
  PTC: 'https://s3-symbol-logo.tradingview.com/ptc--big.svg',
  CANG: 'https://s3-symbol-logo.tradingview.com/cango--big.svg',
  WRB: 'https://s3-symbol-logo.tradingview.com/berkley-w-r-corp--big.svg',
  EQIX: 'https://s3-symbol-logo.tradingview.com/equinix--big.svg',
  GD: 'https://s3-symbol-logo.tradingview.com/general-dynamics--big.svg',
  CPT: 'https://s3-symbol-logo.tradingview.com/camden-property-trust--big.svg',
  KLAC: 'https://s3-symbol-logo.tradingview.com/kla-tencor--big.svg',
  NOW: 'https://s3-symbol-logo.tradingview.com/servicenow--big.svg',
  GRMN: 'https://s3-symbol-logo.tradingview.com/garmin-ltd--big.svg',
  AOS: 'https://s3-symbol-logo.tradingview.com/smith-a-o--big.svg',
  HIG: 'https://s3-symbol-logo.tradingview.com/hartford-financial-services-grp--big.svg',
  GDDY: 'https://s3-symbol-logo.tradingview.com/godaddy--big.svg',
  AWK: 'https://s3-symbol-logo.tradingview.com/american-water-works--big.svg',
  LDOS: 'https://s3-symbol-logo.tradingview.com/leidos-holdings--big.svg',
  ESS: 'https://s3-symbol-logo.tradingview.com/essex-property-trust--big.svg',
  WAB: 'https://s3-symbol-logo.tradingview.com/wabtec--big.svg',
  HCA: 'https://s3-symbol-logo.tradingview.com/hca-healthcare--big.svg',
  SOLV: 'https://s3-symbol-logo.tradingview.com/solventum--big.svg',
  AVY: 'https://s3-symbol-logo.tradingview.com/avery-dennison--big.svg',
  CBRE: 'https://s3-symbol-logo.tradingview.com/cbre-group--big.svg',
  MELI: 'https://s3-symbol-logo.tradingview.com/mercadolibre--big.svg',
  IT: 'https://s3-symbol-logo.tradingview.com/gartner--big.svg',
  FOX: 'https://s3-symbol-logo.tradingview.com/fox-corporation--big.svg',
  SYK: 'https://s3-symbol-logo.tradingview.com/stryker--big.svg',
  ECL: 'https://s3-symbol-logo.tradingview.com/ecolab--big.svg',
  WTW: 'https://s3-symbol-logo.tradingview.com/willis-towers-watson--big.svg',
  IDXX: 'https://s3-symbol-logo.tradingview.com/idexx-laboratories--big.svg',
  SBAC: 'https://s3-symbol-logo.tradingview.com/sba-communications--big.svg',
  RL: 'https://s3-symbol-logo.tradingview.com/ralph-lauren--big.svg',
  COR: 'https://s3-symbol-logo.tradingview.com/amerisourcebergen--big.svg',
  TRV: 'https://s3-symbol-logo.tradingview.com/travelers--big.svg',
  PFG: 'https://s3-symbol-logo.tradingview.com/principal--big.svg',
  ROK: 'https://s3-symbol-logo.tradingview.com/rockwell-automation--big.svg',
  ANSS: 'https://s3-symbol-logo.tradingview.com/ansys--big.svg',
  AME: 'https://s3-symbol-logo.tradingview.com/ametek--big.svg',
  RMD: 'https://s3-symbol-logo.tradingview.com/resmed--big.svg',
  EXPD: 'https://s3-symbol-logo.tradingview.com/expeditors--big.svg',
  DVA: 'https://s3-symbol-logo.tradingview.com/davita--big.svg',
  RJF: 'https://s3-symbol-logo.tradingview.com/raymond-james--big.svg',
  MHK: 'https://s3-symbol-logo.tradingview.com/mohawk-industries--big.svg',
  AVB: 'https://s3-symbol-logo.tradingview.com/avalonbay-communities--big.svg',
  PAYC: 'https://s3-symbol-logo.tradingview.com/paycom-software--big.svg',
  MTB: 'https://s3-symbol-logo.tradingview.com/m-and-t-bank--big.svg',
  VRSK: 'https://s3-symbol-logo.tradingview.com/verisk-analytics--big.svg',
  CDW: 'https://s3-symbol-logo.tradingview.com/cdw--big.svg',
  AXON: 'https://s3-symbol-logo.tradingview.com/axon-enterprise--big.svg',
  DOV: 'https://s3-symbol-logo.tradingview.com/dover--big.svg',
  LHX: 'https://s3-symbol-logo.tradingview.com/l3-harris--big.svg',
  PNW: 'https://s3-symbol-logo.tradingview.com/pinnacle-west-capital--big.svg',
  GPC: 'https://s3-symbol-logo.tradingview.com/gpc--big.svg',
  SNA: 'https://s3-symbol-logo.tradingview.com/snap-on--big.svg',
  ULTA: 'https://s3-symbol-logo.tradingview.com/ulta-beauty--big.svg',
  MCO: 'https://s3-symbol-logo.tradingview.com/moodys--big.svg',
  MAA: 'https://s3-symbol-logo.tradingview.com/mid-america-apartment-communities--big.svg',
  VLTO: 'https://s3-symbol-logo.tradingview.com/veralto--big.svg',
  ALLE: 'https://s3-symbol-logo.tradingview.com/allegion-plc--big.svg',
  MCK: 'https://s3-symbol-logo.tradingview.com/mckesson--big.svg',
  PH: 'https://s3-symbol-logo.tradingview.com/parker-hannifin--big.svg',
  NOC: 'https://s3-symbol-logo.tradingview.com/northrop-grumman--big.svg',
  AON: 'https://s3-symbol-logo.tradingview.com/aon--big.svg',
  UHS: 'https://s3-symbol-logo.tradingview.com/universal-health-services--big.svg',
  CBOE: 'https://s3-symbol-logo.tradingview.com/cboe-global-markets--big.svg',
  RVTY: 'https://s3-symbol-logo.tradingview.com/perkinelmer--big.svg',
  WST: 'https://s3-symbol-logo.tradingview.com/west-pharmaceutical-services--big.svg',
  FRT: 'https://s3-symbol-logo.tradingview.com/federal-realty-investment-trust--big.svg',
  GNRC: 'https://s3-symbol-logo.tradingview.com/generac--big.svg',
  CRL: 'https://s3-symbol-logo.tradingview.com/charles-river-laboratories--big.svg',
  PSA: 'https://s3-symbol-logo.tradingview.com/public-storage--big.svg',
  EFX: 'https://s3-symbol-logo.tradingview.com/equifax--big.svg',
  TYL: 'https://s3-symbol-logo.tradingview.com/tyler-technologies--big.svg',
  ALGN: 'https://s3-symbol-logo.tradingview.com/align-technology--big.svg',
  POOL: 'https://s3-symbol-logo.tradingview.com/pool--big.svg',
  TFX: 'https://s3-symbol-logo.tradingview.com/teleflex--big.svg',
  L: 'https://s3-symbol-logo.tradingview.com/loews--big.svg',
  KEYS: 'https://s3-symbol-logo.tradingview.com/keysight-technologies--big.svg',
  VMC: 'https://s3-symbol-logo.tradingview.com/vulcan-materials--big.svg',
  HII: 'https://s3-symbol-logo.tradingview.com/huntington-ingalls-industries--big.svg',
  CPAY: 'https://s3-symbol-logo.tradingview.com/fleetcor-technologies--big.svg',
  DGX: 'https://s3-symbol-logo.tradingview.com/quest-diagnostics--big.svg',
  LII: 'https://s3-symbol-logo.tradingview.com/lennox-international--big.svg',
  AMP: 'https://s3-symbol-logo.tradingview.com/ameriprise-financial--big.svg',
  CMI: 'https://s3-symbol-logo.tradingview.com/cummins--big.svg',
  ATO: 'https://s3-symbol-logo.tradingview.com/atmos-energy--big.svg',
  CINF: 'https://s3-symbol-logo.tradingview.com/cincinnati-financial--big.svg',
  JKHY: 'https://s3-symbol-logo.tradingview.com/henry-jack-and-associates--big.svg',
  NWS: 'https://s3-symbol-logo.tradingview.com/news-corporation--big.svg',
  VRSN: 'https://s3-symbol-logo.tradingview.com/verisign--big.svg',
  MSCI: 'https://s3-symbol-logo.tradingview.com/msci--big.svg',
  WAT: 'https://s3-symbol-logo.tradingview.com/waters--big.svg',
  ROP: 'https://s3-symbol-logo.tradingview.com/roper-technologies--big.svg',
  MPWR: 'https://s3-symbol-logo.tradingview.com/monolithic-power-system--big.svg',
  LH: 'https://s3-symbol-logo.tradingview.com/laboratory-amer--big.svg',
  DPZ: 'https://s3-symbol-logo.tradingview.com/dominos-pizza--big.svg',
  FFIV: 'https://s3-symbol-logo.tradingview.com/f5-network--big.svg',
  J: 'https://s3-symbol-logo.tradingview.com/jacobs-engineering--big.svg',
  ZBRA: 'https://s3-symbol-logo.tradingview.com/zebra--big.svg',
  MKTX: 'https://s3-symbol-logo.tradingview.com/marketaxess--big.svg',
  BLK: 'https://s3-symbol-logo.tradingview.com/blackrock--big.svg',
  IEX: 'https://s3-symbol-logo.tradingview.com/idex--big.svg',
  TDG: 'https://s3-symbol-logo.tradingview.com/transdigm-group--big.svg',
  EPAM: 'https://s3-symbol-logo.tradingview.com/epam-sys--big.svg',
  MLM: 'https://s3-symbol-logo.tradingview.com/martin-marietta--big.svg',
  HUBB: 'https://s3-symbol-logo.tradingview.com/hubbell--big.svg',
  URI: 'https://s3-symbol-logo.tradingview.com/united-rentals--big.svg',
  GL: 'https://s3-symbol-logo.tradingview.com/globe-life--big.svg',
  EG: 'https://s3-symbol-logo.tradingview.com/everest-re--big.svg',
  NDSN: 'https://s3-symbol-logo.tradingview.com/nordson--big.svg',
  BR: 'https://s3-symbol-logo.tradingview.com/broadridge--big.svg',
  BKNG: 'https://s3-symbol-logo.tradingview.com/booking--big.svg',
  TDY: 'https://s3-symbol-logo.tradingview.com/teledyne-technologies--big.svg',
  AIZ: 'https://s3-symbol-logo.tradingview.com/assurant--big.svg',
  FICO: 'https://s3-symbol-logo.tradingview.com/fair-isaac--big.svg',
  GWW: 'https://s3-symbol-logo.tradingview.com/grainger--big.svg',
  FDS: 'https://s3-symbol-logo.tradingview.com/factset-research-systems--big.svg',
  AZO: 'https://s3-symbol-logo.tradingview.com/autozone--big.svg',
  MTD: 'https://s3-symbol-logo.tradingview.com/mettler-toledo-international--big.svg',
  TPL: 'https://s3-symbol-logo.tradingview.com/texas-pacific-land-corporation--big.svg',
  ERIE: 'https://s3-symbol-logo.tradingview.com/erie-indemnity--big.svg',
  NVR: 'https://s3-symbol-logo.tradingview.com/nvr--big.svg',
  QQQ: 'https://s3-symbol-logo.tradingview.com/invesco--big.svg',
  SCHD: 'https://s3-symbol-logo.tradingview.com/schwab--big.svg',
  JEPQ: 'https://s3-symbol-logo.tradingview.com/jpmorgan--big.svg',
  NDX: 'https://s3-symbol-logo.tradingview.com/indices/nasdaq-100--big.svg',
  SPX: 'https://s3-symbol-logo.tradingview.com/indices/s-and-p-500--big.svg',
  SBET: 'https://s3-symbol-logo.tradingview.com/sharplink-gaming--big.svg',
  BMNR: 'https://s3-symbol-logo.tradingview.com/bitmine-immersion-technologies--big.svg',
  NAKA: 'https://s3-symbol-logo.tradingview.com/kindly-md--big.svg',
  UPXI: 'https://s3-symbol-logo.tradingview.com/grove-inc--big.svg',
  DFDV: 'https://s3-symbol-logo.tradingview.com/janover--big.svg',
  ALTS: 'https://s3-symbol-logo.tradingview.com/janone--big.svg',
  STKE: 'https://s3-symbol-logo.tradingview.com/cypherpunk-hldgs--big.svg',
  STSS: 'https://s3-symbol-logo.tradingview.com/sharps-technology--big.svg',
  KLAR: 'https://s3-symbol-logo.tradingview.com/klarna--big.svg',
  FIGR: 'https://s3-symbol-logo.tradingview.com/figure-technologies--big.svg',
  GEMI: 'https://s3-symbol-logo.tradingview.com/crypto/XTVCGUSD--big.svg',
  FORD: 'https://s3-symbol-logo.tradingview.com/forward-industries--big.svg',
  HSDT: 'https://s3-symbol-logo.tradingview.com/helius-medical-technologies--big.svg',
  HYPD: 'https://s3-symbol-logo.tradingview.com/eyenovia--big.svg',
  BREA: 'https://s3-symbol-logo.tradingview.com/brera-plc--big.svg',
  URA: 'https://s3-symbol-logo.tradingview.com/global-x--big.svg',
  CCJ: 'https://s3-symbol-logo.tradingview.com/cameco--big.svg',
  HOND: 'https://s3-symbol-logo.tradingview.com/hcm-ii-acquisition--big.svg',
  UUU: 'https://s3-symbol-logo.tradingview.com/universal-security-instruments--big.svg',
  AGRI: 'https://s3-symbol-logo.tradingview.com/agriforce-growing-systems-ltd--big.svg',
  CLSK: 'https://s3-symbol-logo.tradingview.com/cleanspark--big.svg',
  GLXY: 'https://s3-symbol-logo.tradingview.com/galaxy-digital--big.svg',
  HUT: 'https://s3-symbol-logo.tradingview.com/hut-8-mining--big.svg',
  WULF: 'https://s3-symbol-logo.tradingview.com/terawulf--big.svg',
  RIVN: 'https://s3-symbol-logo.tradingview.com/rivian--big.svg',
  SPY: 'https://s3-symbol-logo.tradingview.com/spdr-sandp500-etf-tr--big.svg',
  QURE: 'https://s3-symbol-logo.tradingview.com/uniqure-n-v--big.svg',
  OSCR: 'https://s3-symbol-logo.tradingview.com/oscar-health--big.svg',
  HIMS: 'https://s3-symbol-logo.tradingview.com/hims-and-hers-health--big.svg',
  OPEN: 'https://s3-symbol-logo.tradingview.com/opendoor--big.svg',
  SOFI: 'https://s3-symbol-logo.tradingview.com/sofi--big.svg',
  BBAI: 'https://s3-symbol-logo.tradingview.com/bigbear-ai--big.svg',
  ZETA: 'https://s3-symbol-logo.tradingview.com/zeta--big.svg',
  CVNA: 'https://s3-symbol-logo.tradingview.com/carvana--big.svg',
  CIFR: 'https://s3-symbol-logo.tradingview.com/cipher-mining--big.svg',
  CROX: 'https://s3-symbol-logo.tradingview.com/crocs--big.svg',
  AEO: 'https://s3-symbol-logo.tradingview.com/american-eagle-outfitters--big.svg',
  IONQ: 'https://s3-symbol-logo.tradingview.com/ionq--big.svg',
  QBTS: 'https://s3-symbol-logo.tradingview.com/d-wave-quantum--big.svg',
  QUBT: 'https://s3-symbol-logo.tradingview.com/quantum-computing--big.svg',
  RGTI: 'https://s3-symbol-logo.tradingview.com/rigetti-computing-redeemable--big.svg',
  AMBI: 'https://s3-symbol-logo.tradingview.com/ambipar-emergency-response--big.svg',
  GDX: 'https://s3-symbol-logo.tradingview.com/vaneck--big.svg',
  GLD: 'https://s3-symbol-logo.tradingview.com/spdr-sandp500-etf-tr--big.svg',
  SIL: 'https://s3-symbol-logo.tradingview.com/global-x--big.svg',
  SLV: 'https://s3-symbol-logo.tradingview.com/ishares--big.svg',
  DKNG: 'https://s3-symbol-logo.tradingview.com/draftkings--big.svg',
  FLUT: 'https://s3-symbol-logo.tradingview.com/flutter-entertainment--big.svg',
  ACHR: 'https://s3-symbol-logo.tradingview.com/archer-aviation--big.svg',
  BETR: 'https://s3-symbol-logo.tradingview.com/better-home-and-finance-company--big.svg',
  IREN: 'https://s3-symbol-logo.tradingview.com/iris-energy--big.svg',
  QS: 'https://s3-symbol-logo.tradingview.com/quantumscape--big.svg',
  SLDP: 'https://s3-symbol-logo.tradingview.com/solid-power--big.svg',
  TMC: 'https://s3-symbol-logo.tradingview.com/the-metals-company--big.svg',
  TMQ: 'https://s3-symbol-logo.tradingview.com/trilogy-metals--big.svg',
  AMKR: 'https://s3-symbol-logo.tradingview.com/amkor-technology--big.svg',
  BKSY: 'https://s3-symbol-logo.tradingview.com/blacksky--big.svg',
  PLAB: 'https://s3-symbol-logo.tradingview.com/photronics--big.svg',
  ASTS: 'https://s3-symbol-logo.tradingview.com/ast-spacemobile--big.svg',
  APLD: 'https://s3-symbol-logo.tradingview.com/applied-digital--big.svg',
  BULL: 'https://s3-symbol-logo.tradingview.com/webull--big.svg',
  DUOL: 'https://s3-symbol-logo.tradingview.com/duolingo--big.svg',
  IBKR: 'https://s3-symbol-logo.tradingview.com/interactive-brokers-group--big.svg',
  REMX: 'https://s3-symbol-logo.tradingview.com/vaneck--big.svg',
  CRML: 'https://s3-symbol-logo.tradingview.com/critical-metals--big.svg',
  NAK: 'https://s3-symbol-logo.tradingview.com/northern-dynasty-minerals--big.svg',
  NIO: 'https://s3-symbol-logo.tradingview.com/niocorp-developments-ltd--big.svg',
  UUUU: 'https://s3-symbol-logo.tradingview.com/energy-fuels--big.svg',
  PPTA: 'https://s3-symbol-logo.tradingview.com/perpetua-resources--big.svg',
  USAR: 'https://s3-symbol-logo.tradingview.com/usa-rare-earth--big.svg',
  MP: 'https://s3-symbol-logo.tradingview.com/mp-materials--big.svg',
  UEC: 'https://s3-symbol-logo.tradingview.com/uranium-energy--big.svg',
  GWAV: 'https://s3-symbol-logo.tradingview.com/greenwave-technology-solutions--big.svg',
  NVA: 'https://s3-symbol-logo.tradingview.com/nova-minerals--big.svg',
  ABAT: 'https://s3-symbol-logo.tradingview.com/american-battery-technology-company--big.svg',
  AMPX: 'https://s3-symbol-logo.tradingview.com/amprius-technologies--big.svg',
  ENVX: 'https://s3-symbol-logo.tradingview.com/enovix--big.svg',
  EOSE: 'https://s3-symbol-logo.tradingview.com/eos-energy-enterprises--big.svg',
  FCEL: 'https://s3-symbol-logo.tradingview.com/fuelcell-energy--big.svg',
  LIT: 'https://s3-symbol-logo.tradingview.com/global-x--big.svg',
  MVST: 'https://s3-symbol-logo.tradingview.com/microvast--big.svg',
  SES: 'https://s3-symbol-logo.tradingview.com/ses-ai--big.svg',
  BITF: 'https://s3-symbol-logo.tradingview.com/bitfarms--big.svg',
  CORZ: 'https://s3-symbol-logo.tradingview.com/core-scientific--big.svg',
  HIVE: 'https://s3-symbol-logo.tradingview.com/hive-blockchain-technologies--big.svg',
  IWM: 'https://s3-symbol-logo.tradingview.com/ishares--big.svg',
  BYND: 'https://s3-symbol-logo.tradingview.com/beyond-meat--big.svg',
  NBIS: 'https://s3-symbol-logo.tradingview.com/nebius-group-nv--big.svg',
  PATH: 'https://s3-symbol-logo.tradingview.com/uipath--big.svg',
  POET: 'https://s3-symbol-logo.tradingview.com/poet-technologies--big.svg',
  RR: 'https://s3-symbol-logo.tradingview.com/richtech-robotics--big.svg',
  XYZ: 'https://s3-symbol-logo.tradingview.com/block--big.svg',
  ZM: 'https://s3-symbol-logo.tradingview.com/zoom-video-communications--big.svg',
  SHOP: 'https://s3-symbol-logo.tradingview.com/shopify--big.svg',
  SPOT: 'https://s3-symbol-logo.tradingview.com/spotify-technology--big.svg',
  BLSH: 'https://s3-symbol-logo.tradingview.com/bullish--big.svg',
  ABTC: 'https://s3-symbol-logo.tradingview.com/american-bitcoin--big.svg',
  STUB: 'https://s3-symbol-logo.tradingview.com/stubhub--big.svg',
  NTSK: 'https://s3-symbol-logo.tradingview.com/netskope--big.svg',
  PTRN: 'https://s3-symbol-logo.tradingview.com/pattern-series-a--big.svg',
  ASTER: 'https://s3-symbol-logo.tradingview.com/crypto/XTVCASTER2--big.svg',
  FRMI: 'https://s3-symbol-logo.tradingview.com/fermi--big.svg',
  ALH: 'https://s3-symbol-logo.tradingview.com/alliance-laundry--big.svg',
  PXED: 'https://s3-symbol-logo.tradingview.com/phoenix-education-partners--big.svg',
  CRWV: 'https://s3-symbol-logo.tradingview.com/coreweave--big.svg',
  SMR: 'https://s3-symbol-logo.tradingview.com/nuscale-power--big.svg',
  ALAB: 'https://s3-symbol-logo.tradingview.com/astera-labs--big.svg',
  ONDS: 'https://s3-symbol-logo.tradingview.com/ondas--big.svg',
  SOUN: 'https://s3-symbol-logo.tradingview.com/soundhound-ai--big.svg',
  BABA: 'https://s3-symbol-logo.tradingview.com/alibaba--big.svg',
  JD: 'https://s3-symbol-logo.tradingview.com/jd-com--big.svg',
  PZZA: 'https://s3-symbol-logo.tradingview.com/papa-johns-international--big.svg',
  XPEV: 'https://s3-symbol-logo.tradingview.com/xpeng--big.svg',
  BIDU: 'https://s3-symbol-logo.tradingview.com/baidu--big.svg',
  FUTU: 'https://s3-symbol-logo.tradingview.com/futu-holdings--big.svg',
  TCOM: 'https://s3-symbol-logo.tradingview.com/ctrip-com-international--big.svg',
  BOX: 'https://s3-symbol-logo.tradingview.com/box--big.svg',
  CYPH: 'https://s3-symbol-logo.tradingview.com/leap-therapeutics--big.svg',
  LYFT: 'https://s3-symbol-logo.tradingview.com/lyft--big.svg',
  NET: 'https://s3-symbol-logo.tradingview.com/cloudflare-inc--big.svg',
  SNDK: 'https://s3-symbol-logo.tradingview.com/sandisk--big.svg',
  MDLN: 'https://s3-symbol-logo.tradingview.com/medline--big.svg',
  USO: 'https://s3-symbol-logo.tradingview.com/uscf-fund--big.svg',
  BTGO: 'https://s3-symbol-logo.tradingview.com/bitgo--big.svg',
  ASST: 'https://s3-symbol-logo.tradingview.com/strive--big.svg',
  NAVN: 'https://s3-symbol-logo.tradingview.com/navan--big.svg',
  RTY: 'https://s3-symbol-logo.tradingview.com/indices/russell-2000--big.svg',
  GC: 'https://s3-symbol-logo.tradingview.com/metal/gold--big.svg',
  SI: 'https://s3-symbol-logo.tradingview.com/metal/silver--big.svg',
  HG: 'https://s3-symbol-logo.tradingview.com/metal/copper--big.svg',
  PL: 'https://s3-symbol-logo.tradingview.com/metal/platinum--big.svg',
  CL: 'https://s3-symbol-logo.tradingview.com/crude-oil--big.svg',
  NG: 'https://s3-symbol-logo.tradingview.com/natural-gas--big.svg',
};

export const FILE_IMAGES = [
  'JUP',
  'RENDER',
  'STABLEDOM',
  'PENDLE',
  'OTHERSDOM',
  'OKLO',
  'STEX',
  'BNC',
  'NAVN',
  'BETA',
  'EQPT',
];

export default TOKEN_IMAGES;
